<template>
  <v-row>
    <v-col cols="12" md="4" xl="3" v-for="home in homes" :key="home.id">
      <home-card :home="home" isPending />
    </v-col>

    <v-col cols="12" v-if="!isLoading && homes.length == 0">
      <div class="d-flex flex-column fill-height align-center justify-center py-16">
        <div class="text-h5 font-weight-medium text-center">No Pending Subscriptions</div>
        <v-btn
          depressed
          small
          tile
          color="secondary"
          class="text-none py-6 px-8 mt-8"
          @click="$emit('handlePending')"
        >Buy House</v-btn>
      </div>
    </v-col>
     <v-col cols="12">
      <v-row v-if="isLoading">
        <v-col cols="12" sm="6" md="4" xl="3" v-for="i in 8" :key="i">
          <v-skeleton-loader
            :max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
            :width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
            v-bind="attrs"
            height="350"
            type="image, article, actions"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { UserService } from "@/services/index.js";
import HomeCard from "@/components/homes/HomeCard.vue";

export default {
  components: {
    HomeCard,
  },
  data(){
    return {
      isLoading: false,
      homes: [],
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 0,
      },
    }
  },
  methods: {
    async loadPendingHomes() {
      try {
        this.isLoading = true;
        const { payments } = await UserService.getHousePayments();
        this.homes = payments;
        this.isLoading = false;
        // console.log(payments)
        // this.activeInvestment = data[0] || {};
      } catch (err) {
        this.isLoading = false;
        // throw err;
      }
    },
  },
  mounted(){
    this.loadPendingHomes()
  }
}
</script>
